import React from 'react'
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink } from "@chakra-ui/react";
import { Link as ReactLink } from 'react-router-dom';


const BreadcrumbMp = (props) => {
    const {
        pagina,
        entidade,
        categoria,
        entidadeHref
    } = props;

    const handlePageName = () => {
        let tempName = '';
        switch (pagina) {
            case 'Cadastrar Gestao':
                tempName = 'Cadastrar Gestão';
                break;
            case 'Editar Gestao':
                tempName = 'Editar Gestão';
                break;
            case 'Visualizar Gestao':
                tempName = 'Visualizar Gestão';
                break;
            case 'Cadastrar Rede De Referencia':
                tempName = 'Cadastrar Rede De Referência';
                break;
            case 'Editar Rede De Referencia':
                tempName = 'Editar Rede De Referência';
                break;
            case 'Visualizar Rede De Referencia':
                tempName = 'Visualizar Rede De Referência';
                break;
            case 'Visualizar Familia Acolhedora':
                tempName = 'Visualizar Família Acolhedora';
                break;
            case 'Cadastrar Documentacao':
                tempName = 'Cadastrar Documentação';
                break;
            case 'Editar Documentacao':
                tempName = 'Editar Documentação';
                break;
            case 'Visualizar Documentacao':
                tempName = 'Visualizar Documentação';
                break;
            case 'Cadastrar Anexos':
                tempName = 'Anexar Documentos';
                break;
            case 'Cadastrar Movimentacao':
                tempName = 'Cadastrar Movimentação';
                break;
            case 'Editar Movimentacao':
                tempName = 'Editar Movimentação';
                break;
            case 'Visualizar Movimentacao':
                tempName = 'Visualizar Movimentação';
                break;
            case 'Cadastrar Ocorrencias':
                tempName = 'Cadastrar Ocorrências';
                break;
            case 'Editar Ocorrencias':
                tempName = 'Editar Ocorrências';
                break;
            case 'Visualizar Ocorrencias':
                tempName = 'Visualizar Ocorrências';
                break;
            case 'Visualizar Pendencias':
                tempName = 'Visualizar Pendências';
                break;
            case "Editar Educacao":
                tempName = "Editar Educação";
                break;
            case "Visualizar Educacao":
                tempName = "Visualizar Educação";
                break;
            case "Editar Profissionalizacao":
                tempName = "Editar Profissionalização";
                break;
            case "Visualizar Profissionalizacao":
                tempName = "Visualizar Profissionalização";
                break;
            case "Editar Saude":
                tempName = "Editar Saúde";
                break;
            case "Visualizar Saude":
                tempName = "Visualizar Saúde";
                break;
            case "Visualizar Referencia Familiar":
                tempName = "Visualizar Referência Familiar";
                break;
            case "Visualizar Situacao Juridica":
                tempName = "Visualizar Situação Jurídica";
                break;
            case "Visualizar Apadrinhamento":
                tempName = "Visualizar Programa de Apadrinhamento";
                break;
            case "Cadastrar Apadrinhamento":
                tempName = "Cadastrar Programa de Apadrinhamento";
                break;
            case "Editar Apadrinhamento":
                tempName = "Editar Programa de Apadrinhamento";
                break;
            default:
                tempName = pagina;
                break;
        }
        return tempName;
    }

    return (
        <Breadcrumb>

            {
                categoria === "Cadastros"
                    ?
                    <BreadcrumbItem>
                        <BreadcrumbLink data-testid="breadcrumb-categoria" style={{ textDecoration: "none", cursor: "inherit" }}>{categoria}</BreadcrumbLink>
                    </BreadcrumbItem>
                    :
                    <BreadcrumbItem>
                        <BreadcrumbLink as={ReactLink} to={"/" + entidadeHref} >{categoria}</BreadcrumbLink>
                    </BreadcrumbItem>
            }

            {
                entidade ? (
                    <BreadcrumbItem>
                        <BreadcrumbLink data-testid="breadcrumb-entidade" as={ReactLink} to={"/" + entidadeHref + "/lista"}>{entidade}</BreadcrumbLink>
                    </BreadcrumbItem>
                ) : ("")
            }


            {pagina ? (
                <BreadcrumbItem isCurrentPage>
                    <BreadcrumbLink data-testid="breadcrumb-pagina" style={{ textDecoration: "none", cursor: "inherit" }} href="#">{handlePageName()}</BreadcrumbLink>
                </BreadcrumbItem>
            ) : ("")}
        </Breadcrumb>
    )
}
export default BreadcrumbMp;
